<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="py-3 px-2 layout row wrap">
          <v-btn class="primary my-0 mx-3" @click='$router.push({ name: "paymentTerminalCreate" })'>{{$lang.actions.paymentTerminalCreate}}</v-btn>
          <v-checkbox
            color="primary"
            class="mx-1 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
          />
          <v-spacer />
          <v-autocomplete
            v-if="!isLocalAdmin"
            class="min-w max-w mx-3 pb-2"
            :label="$lang.actions.selectCompany"
            :items="mappedCompanies"
            v-model="selectedCompany"
            hide-details
          />
          <v-text-field
            v-if="show"
            class="min-w max-w mx-3 pb-2"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          v-if="show"
          :headers="headers"
          :items="showActive ? activeTerminals : allTerminals"
          :search="search"
          :loading="loading"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.status }}</td>
            <td class="min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="goToTerminal(props.item)">{{$lang.actions.edit}}</v-btn>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data() {
      return {
        err: '',
        search: '',
        loading: false,
        show: false,
        selectedCompany: null,
        companies: [],
        headers: [
          {text: this.$lang.labels.name, value: 'name', align: 'left' },
          {text: this.$lang.labels.status, value: 'status', align: 'left' },
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        showActive: true,
        allTerminals: [],
        isLocalAdmin: true,
      };
    },
    methods: {
      goToTerminal(terminal) {
        localStorage.selectedTerminal = terminal.companyId;
        this.$router.push({ name: 'paymentTerminal', params: { id: terminal.id } });
      },
      changeStatus(terminal) {
        const action = terminal.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`paymentterminal/${action}/${terminal.id}?companyId=${terminal.companyId}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(terminal, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      },
      fetchTerminalsForCompany(id) {
        this.loading = true;
        this.allTerminals = [];
        this.$http.get(`paymentterminal/list?companyId=${id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.loading = false;
            this.allTerminals = res.body.terminals;
            if (this.allTerminals.length === 0){
              this.loading = false;
            }
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.loading = false;
          this.err = err.body.statusText || err.body.message;
        });
      }
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      selectedCompany(val) {
        this.show = true;
        this.fetchTerminalsForCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
    },
    computed: {
      activeTerminals() {
        const terminals = this.allTerminals;
        const activeTerminals = [];
        for (let i=0; terminals.length > i; i++) {
          if (terminals[i].status === 'active') {
            activeTerminals.push(terminals[i]);
          }
        }
        return activeTerminals;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    created() {
      this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
      this.$http.get('company')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.companies = res.body.companies;
            if (this.isLocalAdmin) {
              this.show = true;
              this.fetchTerminalsForCompany(this.companies[0].id);
            }
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      const edit = this.$cookie.get('companyedit');
      if (edit) this.selectedCompany = edit;
    },
  };
</script>



// WEBPACK FOOTER //
// PaymentTerminals.vue?6958d91a